import { render, staticRenderFns } from "./IconArrowDoubleRight.vue?vue&type=template&id=07644c40&"
import script from "./IconArrowDoubleRight.vue?vue&type=script&lang=ts&"
export * from "./IconArrowDoubleRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports